import { render } from "./EditarUsuarioModal.vue?vue&type=template&id=1189f183&scoped=true"
import script from "./EditarUsuarioModal.vue?vue&type=script&lang=js"
export * from "./EditarUsuarioModal.vue?vue&type=script&lang=js"

import "./EditarUsuarioModal.vue?vue&type=style&index=0&id=1189f183&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1189f183"]])

export default __exports__